import { render } from "./FeedbackForm.vue?vue&type=template&id=1947e855&scoped=true&ts=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=ts"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts"

import "./FeedbackForm.vue?vue&type=style&index=0&id=1947e855&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1947e855"]])

export default __exports__